import { i18n } from '@shared/i18n';

export default enumName => {
    return require(`@enums/${enumName}.json`).map(value => {
        return {
            id: value,
            label: i18n(`enumerators.${enumName}.${value}`)
        };
    });
};
